import React from "react";
import InteractiveContentWrapper from "@icoach/components/InteractiveContentWrapper";

const InBodyInterviewHealthAssessmentReportLabel = () => {
	const tip = `綜合健康評估\n個人成績單\n全台分組成績單`;
	const title = `綜合健康評估`;
	return <InteractiveContentWrapper tip={tip} label={title} justifyContent="end" iconSize="20px" />;
};

export default InBodyInterviewHealthAssessmentReportLabel;